import { Flex, FlexProps } from '@mantine/core';

import cx from './EmptyMessage.module.scss';

const EmptyMessage = ({ children, ...props }: { children: React.ReactNode } & FlexProps) => {
    return (
        <Flex align="center" justify="center" fz="sm" className={cx.root} data-empty-message {...props}>
            {children}
        </Flex>
    );
};

export { EmptyMessage };
